<script module>
    export { default as layout } from '../../layouts/AdminLayout.svelte';
</script>

<script lang="ts">
    import { Link, router } from '@inertiajs/svelte';
    import DataTable from '../../components/DataTable.svelte';
    import { create, edit } from '@/routes/admin/topics';
    import { topics as topicsRoute } from '@/routes/admin';

    interface Topic {
        id: number;
        name: string;
        slug: string;
        disabled: boolean;
        not_for_credit: boolean;
        cases_count: number;
    }

    let { topics, sort = 'name', direction = 'asc' }: { topics: Topic[]; sort: string; direction: 'asc' | 'desc' } = $props();

    function handleSort(key: string, dir: 'asc' | 'desc') {
        router.visit(topicsRoute({ mergeQuery: { sort: key, direction: dir } }), {
            preserveScroll: true,
            preserveState: true,
        });
    }

    const columns = [
        { key: 'name', label: 'Name', grow: true },
        { key: 'disabled', label: 'Status' },
        { key: 'not_for_credit', label: 'Credit' },
        { key: 'cases_count', label: 'Cases' },
        { key: null, label: 'Actions', align: 'right' as const },
    ];
</script>

<svelte:head>
    <title>Topics — Admin — Case of the Day</title>
</svelte:head>

<div class="flex items-center justify-between mb-6">
    <h1 class="text-2xl font-bold text-gray-100">Topics</h1>
    <Link
        href={create()}
        class="bg-cyan-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-cyan-500 transition-colors"
    >
        Add Topic
    </Link>
</div>

<DataTable
    {columns}
    items={topics}
    {sort}
    {direction}
    onsort={handleSort}
    onrowclick={(topic) => router.visit(edit.url(topic.slug))}
    empty="No topics yet. Add one above."
>
    {#snippet row(topic)}
        <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-100" class:opacity-50={topic.disabled}>
            {topic.name}
        </td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">
            {#if topic.disabled}
                <span class="inline-flex items-center rounded-full bg-red-950 px-2.5 py-0.5 text-xs font-medium text-red-400">Disabled</span>
            {:else}
                <span class="inline-flex items-center rounded-full bg-green-950 px-2.5 py-0.5 text-xs font-medium text-green-400">Active</span>
            {/if}
        </td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">
            {#if topic.not_for_credit}
                <span class="inline-flex items-center rounded-full bg-amber-950 px-2.5 py-0.5 text-xs font-medium text-amber-400">Not for Credit</span>
            {:else}
                <span class="inline-flex items-center rounded-full bg-green-950 px-2.5 py-0.5 text-xs font-medium text-green-400">For Credit</span>
            {/if}
        </td>
        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{topic.cases_count}</td>
        <td class="px-6 py-4 whitespace-nowrap text-right text-sm">
            <Link href={edit(topic.slug)} class="text-cyan-400 hover:text-cyan-300 font-medium">Edit</Link>
        </td>
    {/snippet}
</DataTable>
